import React from 'react';
import styled from 'styled-components';

import { sensitiveClassProps } from 'components/lib/higherOrder/withSensitiveData';
import type { BreadcrumbItem } from 'components/lib/ui/Breadcrumbs';
import Breadcrumbs from 'components/lib/ui/Breadcrumbs';
import Flex from 'components/lib/ui/Flex';
import Header from 'components/routes/Header';

const FlexNoOverflow = styled(Flex)`
  overflow: hidden;
  height: 100%;
`;

type Props = {
  icon?: React.ReactNode;
  /** The name of the page */
  name: string;
  /** Dynamic title to override the page. Used just for display. */
  overrideTitle?: string;
  controls?: React.ReactNode;
  /** Tabs component to show when page has sub routes. */
  tabs?: React.ReactNode;
  titleIsSensitive?: boolean;
  breadcrumbs?: BreadcrumbItem[];
};

const PageHeader = ({
  controls,
  icon,
  titleIsSensitive,
  overrideTitle,
  tabs,
  name,
  breadcrumbs = [],
}: Props) => {
  const title = overrideTitle ?? name;

  const breadcrumbItems = [...breadcrumbs, { label: title, icon }];

  return (
    <Header controls={controls}>
      <FlexNoOverflow alignCenter {...(titleIsSensitive ? sensitiveClassProps : {})}>
        <Breadcrumbs items={breadcrumbItems} />
        {tabs}
      </FlexNoOverflow>
    </Header>
  );
};

export default PageHeader;
